import { Link, Text } from '@ui/atoms';
import { getIdForHtmlElement as getId } from '@helpers/miscelleanous';
import { isFDFeatureEnabled } from '@components/Products/FixedDeposits/utils/helper';

const SpanElement = ({ content, className }) => (
    <span className="p4-semibold md:p3-semibold">{content}</span>
);

const nseBankDetails = [
    {
        title: 'Bank Name',
        value: 'HDFC Bank Limited',
    },
    {
        title: 'Beneficiary Name',
        value: 'NSE Clearing Limited',
    },
    {
        title: 'Bank IFSC Code',
        value: 'HDFC0000060',
    },
    {
        title: 'Bank Account no.',
        value: 'CBRIC1XXXXXXXXXX (where "XXXXXXXXXX" is the PAN of Buyer) For example: If PAN number is ABCDE1234F then beneficiary Account number shall be "CBRIC1ABCDE1234F".',
    },
];

const nseRTGSBankDetails = [
    {
        title: 'Bank Name',
        value: 'Reserve Bank of India',
    },
    {
        title: 'Beneficiary Name',
        value: 'NSE Clearing Ltd',
    },
    {
        title: 'Bank IFSC Code',
        value: 'XNSE0000001',
    },
    {
        title: 'Bank Account no.',
        value: '8715106',
    },
];

export const FAQs = [
    //General Information
    {
        header: 'General Information',
        id: getId('General Information'),
        questionBank: [
            {
                question: 'What is Jiraaf?',
                answer: (
                    <>
                        Jiraaf is a SEBI-registered Online Bond Platform
                        Provider that enables customers like you to invest in
                        fixed-income securities like bonds and mutual funds
                        conveniently.
                    </>
                ),
            },
            {
                question: 'Who can invest in Jiraaf?',
                answer: (
                    <>
                        Anyone with an active bank account, mobile number, and
                        Demat account can invest with Jiraaf, provided they have
                        the required KYC documentation ready.
                    </>
                ),
            },
            {
                question: 'Is Jiraaf SEBI regulated?',
                answer: (
                    <>
                        Yes, Jiraaf is SEBI-registered and compliant with all
                        the prevailing regulations laid out by the governing
                        bodies.
                    </>
                ),
            },
            {
                question:
                    'What types of investment products does Jiraaf offer?',
                answer: (
                    <>
                        Jiraaf offers fixed-income investment instruments like
                        listed corporate bonds, government securities,
                        securitized debt instruments (SDIs), and T-bills.
                    </>
                ),
            },
            {
                question:
                    'How are listed bonds better than unlisted, unregulated bonds?',
                answer: (
                    <>
                        Listed bonds are regulated by SEBI and are traded on the
                        exchanges (NSE & BSE), making them more liquid than
                        unlisted bonds. Listed bonds are credit rated by
                        external credit rating agencies, while unlisted bonds
                        can be rated or unrated. Unlisted bonds are issued
                        privately to a limited set of investors. Investments in
                        both listed and unlisted bonds show up in your Demat
                        account.
                    </>
                ),
            },
            {
                question:
                    'What is the credit rating of the corporate bonds offered on Jiraaf?',
                answer: (
                    <>
                        A credit rating is an assessment of a company’s
                        creditworthiness, representing its ability to repay debt
                        and meet its financial obligations. These ratings are
                        issued by external and independent rating agencies like
                        ICRA, CRISIL, CARE Ratings, India Ratings, etc. Bonds
                        offered by Jiraaf generally carry a rating between BBB-
                        and AAA.
                    </>
                ),
            },
            {
                question:
                    'Are these bonds sold exclusively on the Jiraaf platform, or are they available elsewhere, including the NSE?',
                answer: (
                    <>
                        All the opportunities listed on the Jiraaf platform are
                        listed and regulated by SEBI. While Jiraaf curates a lot
                        of opportunities with borrowing companies exclusively
                        available to investors using the Jiraaf platform, it
                        also lists opportunities that are traded more broadly,
                        giving customers the option to build diversified bond
                        portfolios.
                    </>
                ),
            },
            {
                question: 'Does Jiraaf offer educational information on bonds?',
                answer: (
                    <>
                        Yes, Jiraaf offers educational information on not just
                        bonds but also fixed-income investing and personal
                        finance through its knowledge centre. The knowledge
                        centre holds blogs, newsletters, FAQs, webinars,
                        calculators, and other valuable information to help you
                        take well-informed decisions.
                    </>
                ),
            },
        ],
    },

    // Eligibility Criteria
    {
        header: 'Eligibility',
        id: getId('Eligibility'),
        questionBank: [
            {
                question:
                    'What are the eligibility criteria for investing in bonds on the Jiraaf platform?',
                answer: <p>To invest in bonds on Jiraaf, you should:</p>,
                subQuestions: [
                    {
                        question: '',
                        answer: (
                            <>
                                Be a citizen of India (applicable for the
                                majority of opportunities)
                            </>
                        ),
                    },
                    {
                        question: '',
                        answer: <>Be above 18 years of age</>,
                    },
                    {
                        question: '',
                        answer: <>Hold an active Demat account</>,
                    },
                    {
                        question: '',
                        answer: <>Have an active bank account</>,
                    },
                    {
                        question: '',
                        answer: <>Have an active mobile number</>,
                    },
                    {
                        question: '',
                        answer: <>Have a valid ID and address proof</>,
                    },
                ],
            },
            {
                question: 'Can a minor invest in bonds?',
                answer: (
                    <>Currently, a minor cannot invest in bonds on Jiraaf.</>
                ),
            },
            {
                question: 'Are NRIs eligible to invest in corporate bonds?',
                answer: (
                    <>
                        You must be an Indian citizen to invest in corporate
                        bonds, but NRIs are permitted to invest in certain
                        government securities and public bond issuances.
                    </>
                ),
            },
        ],
    },
    // Registration & KYC
    {
        header: 'Registration and KYC',
        id: getId('Registration and KYC'),
        questionBank: [
            {
                question: 'How do I register on Jiraaf?',
                answer: (
                    <>
                        You can easily register on Jiraaf with your name, mobile
                        number, and email address. After that, you need to
                        complete your KYC process, and you can begin investing.
                    </>
                ),
            },
            {
                question: 'What documents are required for KYC?',
                answer: (
                    <>
                        To complete your KYC on Jiraaf and begin investing, you
                        need your PAN details, Aadhaar details, bank account
                        information with an IFSC code, and Demat account
                        details.
                    </>
                ),
            },
            {
                question: 'What is the process of KYC verification?',
                answer: (
                    <p className="mb-2">
                        Upon submitting all the required information, your KYC
                        will undergo a two-step verification process:
                    </p>
                ),
                subQuestions: [
                    {
                        question: 'Step 1',
                        answer: <>Jiraaf will verify your information.</>,
                    },
                    {
                        question: 'Step 2',
                        answer: (
                            <>
                                The Exchange (NSE) will verify your KYC
                                information. This process could take up to 24
                                hours.
                            </>
                        ),
                    },
                ],
                note: (
                    <>
                        In case of any challenges, Jiraaf will work with you to
                        complete the KYC verification.',
                    </>
                ),
            },
            {
                question: 'What if my verification fails?',
                answer: (
                    <>
                        In the event of any issue or rejection pertaining to
                        your KYC, Jiraaf will work with you to retry and
                        complete the process with the NSE or the platform.
                    </>
                ),
            },
        ],
    },
    //Investment
    {
        header: 'Investment Amount',
        id: getId('Investment Amount'),
        questionBank: [
            {
                question:
                    'What is the minimum investment amount required on Jiraaf?',
                answer: (
                    <>
                        The minimum investment amount on Jiraaf is approximately
                        ₹1,000. However, this may be different for different
                        products. Please refer to specific investment
                        opportunities for their respective minimum investment
                        amount.
                    </>
                ),
            },
            {
                question:
                    'Does the amount required to invest in each opportunity change daily?',
                answer: (
                    <>
                        Based on the accrued interest, premium, and discounts,
                        the price per unit for the different opportunities are
                        subjected to change.
                    </>
                ),
                subQuestions: [
                    {
                        question: '',
                        answer: (
                            <>
                                Accrued interest is the portion of the interest
                                accumulated on a bond from the last repayment
                                date until the date of the bond's sale or
                                purchase.
                            </>
                        ),
                    },
                    {
                        question: '',
                        answer: (
                            <>
                                Premium refers to a bond that trades for a
                                higher amount than its face value in the
                                secondary market. This happens when the bond's
                                coupon rate is higher than the current market
                                interest rate for similar bonds.
                            </>
                        ),
                    },
                    {
                        question: '',
                        answer: (
                            <>
                                Discount refers to a bond that trades for less
                                than its face or par value in the secondary
                                market. This occurs when the bond's coupon rate
                                (the interest rate it pays) is lower than the
                                current market interest rate for similar bonds.
                                Investors are essentially buying the bond at a
                                lower price but will receive the full face value
                                of the bond at maturity.
                            </>
                        ),
                    },
                ],
            },
        ],
    },
    // Pre-Investment
    {
        header: 'Pre-Investment',
        id: getId('Pre-Investment'),
        questionBank: [
            {
                question:
                    'Are there any risks associated with investment opportunities on Jiraaf?',
                answer: (
                    <>
                        The opportunities listed on Jiraaf have been
                        risk-assessed through our robust credit risk framework.
                        Nonetheless, it is important to note that all
                        investments carry risk. In cases of default or other
                        unforeseen circumstances, the investor may lose 100% of
                        both the principal and interest amount.
                    </>
                ),
            },
            {
                question: 'How do I find opportunities to invest on Jiraaf?',
                answer: (
                    <>
                        After you log in or sign up on Jiraaf, you can access
                        all the available investment opportunities. You can
                        select any opportunity and review all the details about
                        it. You can always consult with your Relationship Manage
                        (RM) if you have any questions regarding any specific
                        opportunities.
                    </>
                ),
            },
            {
                question: 'What is a Demat Account Number?',
                answer: (
                    <>
                        Investors can hold shares and securities electronically
                        with the help of a Demat account, which is a
                        user-specific 16-digit number. A Demat account helps you
                        keep track of all your investments. Demat accounts are
                        much safer than physical certificates since you won’t
                        lose or misplace them, unlike a physical certificate.
                    </>
                ),
            },
            {
                question: 'How can I find my Demat Account Number?',
                answer: (
                    <>
                        Upon opening a Demat account with a CSDL or
                        NSDL-affiliated broker firm (examples of broker firms
                        include Zerodha, Grow, HDFC securities, ICICI
                        securities, etc.), you’ll receive a welcome letter with
                        your account number. You can also find the account
                        number by checking previous monthly statements provided
                        by your brokerage firm. The Demat Account number
                        includes both the client ID and DP ID (8 digits each),
                        which are mentioned in the welcome letter.
                    </>
                ),
            },
        ],
    },
    // Post-Investment
    {
        header: 'Post-Investment',
        id: getId('Post-Investment'),
        questionBank: [
            {
                question: 'How do I monitor my investments?',
                answer: (
                    <>
                        Log in to Jiraaf’s website. The dashboard will provide
                        detailed information about your investments. We will
                        also send you periodic notifications tied to your
                        investments. Keep an eye out on your registered email
                        address.
                    </>
                ),
            },
            {
                question:
                    'Will I get my money back if a transaction fails during the payment process?',
                answer: (
                    <>
                        Yes, you will get your money back if an online
                        transaction fails. However, as per RBI guidelines and
                        depending on the payment gateway, it could take five to
                        ten business days for the amount to be returned and
                        reflected in your bank account.
                    </>
                ),
            },
            {
                question:
                    'How long does it take for my purchased units to reflect in my Demat account?',
                answer: (
                    <>
                        Once the transaction is successful, the purchased units
                        will be reflected in your Demat account on the
                        settlement day which would be 1 to 2 business days.
                    </>
                ),
            },
            {
                question: `How can I liquidate or sell my bonds after I've made the purchase?`,
                answer: (
                    <>
                        The purchased bond units are tradable. However, Jiraaf
                        does not facilitate the liquidation on its platform
                        after you’ve made the purchase. You can sell the bonds
                        separately if you find a buyer in the market.
                    </>
                ),
            },
        ],
    },
    // PAYMENT
    {
        header: 'Payment',
        id: getId('Payment'),
        questionBank: [
            // {
            //     question: 'What are the payment modes available on Jiraaf?',
            //     answer: (
            //         <p>
            //             Currently, there are only three modes of payment with the Exchange.
            //         </p>
            //     ),
            //     subQuestions: [
            //         {
            //             question: '',
            //             answer: (
            //                 <>
            //                     UPI
            //                 </>
            //             ),
            //         },
            //         {
            //             question: '',
            //             answer: (
            //                 <>
            //                     NetBanking Payment Gateway(If your bank is supported by NSE)
            //                 </>
            //             ),
            //         },
            //         {
            //             question: '',
            //             answer: (
            //                 <>
            //                     NEFT/RTGS
            //                 </>
            //             ),
            //         },
            //     ],
            //     note: (
            //         <>
            //             The banks supported by NSE are listed below:
            //             <ul className="ml-8 mt-2 [list-style-type:circle]">
            //                 <li> CITY UNION BANK LIMITED </li>
            //                 <li> KARUR VYSYA BANK </li>
            //                 <li> YES BANK </li>
            //                 <li> FEDERAL BANK </li>
            //                 <li> BANK OF INDIA </li>
            //                 <li> NKGSB COOPERATIVE BANK LIMITED </li>
            //                 <li> DHANALAKSHMI BANK </li>
            //                 <li> HDFC BANK </li>
            //                 <li> ICICI BANK LIMITED </li>
            //                 <li> AXIS BANK </li>
            //                 <li> STATE BANK OF INDIA </li>
            //                 <li> UNION BANK OF INDIA </li>
            //                 <li> INDIAN OVERSEAS BANK </li>
            //                 <li> KOTAK MAHINDRA BANK LIMITED </li>
            //                 <li> AU SMALL FINANCE BANK LIMITED </li>
            //                 <li> SARASWAT COOPERATIVE BANK LIMITED </li>
            //             </ul>
            //             *These might be subject to change as per NSE policy.
            //         </>
            //     ),
            // },

            // {
            //     question: 'Are there any aggregator charges for NetBanking?',
            //     answer: (
            //         <>
            //             Aggregator charges for Net Banking:
            //         </>
            //     ),
            //     subQuestions: [
            //         {
            //             question: 'SBI',
            //             answer: (
            //                 <>Rs 12 + GST</>
            //             )
            //         },
            //         {
            //             question: 'ICICI/Axis/HDFC Bank',
            //             answer: (
            //                 <>Rs 12 + GST</>
            //             )
            //         },
            //         {
            //             question: 'Other Banks',
            //             answer: (
            //                 <>Rs 10 + GST</>
            //             )
            //         },
            //     ],
            //     note: (
            //         <>
            //             Note: Charges are applicable to changes as per NSE and payment aggregator policies.
            //         </>
            //     ),
            // },
            // {
            //     question: 'How should I transfer funds if my bank is not supported by NetBanking on NSE?',
            //     answer: (
            //         <p>
            //             NSE supports a select number of banks for NetBanking. If your bank is not supported by the Exchange (NSE), you will have two options to make the payment.
            //         </p>
            //     ),
            //     subQuestions: [
            //         {
            //             question: '',
            //             answer: (
            //                 <>
            //                     Payment via UPI, which can be made anytime until 3:30 PM IST on the settlement date.
            //                 </>
            //             ),
            //         },
            //         {
            //             question: '',
            //             answer: (
            //                 <>
            //                     Payment via NEFT/RTGS, which should be made on the settlement date only before 3:30 PM IST.
            //                 </>
            //             ),
            //         },
            //     ],
            //     note: (
            //         <p>
            //             Note: Settlement day (T+1) is the next working day after the order raised date (T) [except AMO]. <br></br>
            //             Your order will be canceled if payment is not made by the settlement due time or if the transferred amount does not match the investment amount, also leading to a PAN-level debarment of 15 days.
            //         </p>
            //     )
            // },
            // {
            //     question: 'Till what time do I need to complete my payment?',
            //     subQuestions: [
            //         {
            //             question: 'NetBanking',
            //             answer: (
            //                 <>
            //                     You must complete the payment before 10 PM IST on the same day the order is placed with the Exchange.
            //                 </>
            //             ),
            //         },
            //         {
            //             question: 'UPI',
            //             answer: (
            //                 <>
            //                     You need to complete the payment before the settlement day (T+1), 3:30 PM IST.
            //                 </>
            //             ),
            //         },
            //         {
            //             question: 'NEFT/RTGS',
            //             answer: (
            //                 <>
            //                     The payment should be made only on the settlement day (T+1) before 3:30 PM IST.
            //                 </>
            //             ),
            //         },
            //     ],
            //     note: (
            //         <>
            //             Note: Settlement day (T+1) is the next working day after the order raised date (T). For example,
            //             <ul className="ml-4 list-disc">
            //                 <li>If the next day is a Saturday or Sunday, the settlement day is Monday.</li>
            //                 <li> If the next day is a public holiday, the settlement day is the next working day. i.e., if an order is raised on October 1st, and the next day is Gandhi Jayanti, the settlement day will be October 3rd [except AMO].</li>
            //             </ul>
            //         </>
            //     )
            // },
            // {
            //     question:
            //         'What are the bank account details of NSE Clearing Corporation?',
            //     answer: (
            //         <>
            //             Below are the bank account details for the{' '}
            //             <Link
            //                 href={'https://www.nscclindia.com/'}
            //                 target={'_blank'}
            //             >
            //                 NSE clearing corporation
            //             </Link>{' '}
            //             that should be added as a beneficiary for direct NEFT/RTGS funds transfer.
            //             Once successfully added, you can begin transferring funds tied to one or
            //             more purchase transactions.
            //             <div className="flex flex-col gap-4 rounded-md text-basicBlack p5-regular">
            //                 <div className="mt-4 text-center p4-underline md:p4-underline">
            //                     NSE Clearing Corporation Bank Account Details
            //                     for Funds Transfer under NEFT{' '}
            //                 </div>
            //                 <div className="max-w-xl mx-auto overflow-hidden border border-b-0 rounded-md w-full">
            //                     <table className="table overflow-hidden w-full">
            //                         <thead>
            //                             <tr>
            //                                 <th className="w-1/2 px-4 py-2 border-b border-r">
            //                                     Description
            //                                 </th>
            //                             </tr>
            //                             <tr>
            //                                 <th className="w-1/2 px-4 py-2 border-b">
            //                                     Details
            //                                 </th>
            //                             </tr>
            //                         </thead>
            //                         <tbody>
            //                             {nseBankDetails.map((each) => (
            //                                 <tr className="">
            //                                     <td className="w-1/2 px-4 py-2 border-b border-r ">
            //                                         {each.title}
            //                                     </td>
            //                                     <td className="w-1/2 px-4 py-2 border-b">
            //                                         {each.value}
            //                                     </td>
            //                                 </tr>
            //                             ))}
            //                         </tbody>
            //                     </table>
            //                 </div>
            //             </div>
            //             <div className="flex flex-col gap-4 rounded-md text-basicBlack p5-regular mb-2">
            //                 <div className="mt-4 text-center p4-underline md:p4-underline">
            //                     NSE Clearing Corporation Bank Account Details for Funds Transfer under RTGS {' '}
            //                 </div>
            //                 <div className="max-w-xl mx-auto overflow-hidden border border-b-0 rounded-md w-full">
            //                     <table className="table overflow-hidden w-full">
            //                         <thead>
            //                             <tr>
            //                                 <th className="w-1/2 px-4 py-2 border-b border-r">
            //                                     Description
            //                                 </th>
            //                             </tr>
            //                             <tr>
            //                                 <th className="w-1/2 px-4 py-2 border-b">
            //                                     Details
            //                                 </th>
            //                             </tr>

            //                         </thead>
            //                         <tbody>
            //                             {nseRTGSBankDetails.map((each) => (
            //                                 <tr className="">
            //                                     <td className="w-1/2 px-4 py-2 border-b border-r ">
            //                                         {each.title}
            //                                     </td>
            //                                     <td className="w-1/2 px-4 py-2 border-b">
            //                                         {each.value}
            //                                     </td>
            //                                 </tr>
            //                             ))}
            //                         </tbody>
            //                     </table>
            //                 </div>
            //             </div>
            //         </>
            //     ),
            //     note: (
            //         <>
            //             Note: Investors should ensure that the payment is made from the bank account registered with the Jiraaf platform. If payment is made from any other bank account, it will be rejected, and the refund will take a minimum of three working days.
            //         </>
            //     )
            // },
            // {
            //     question:
            //         'Do I transfer funds to Jiraaf or clearing corporation to complete my transaction?',
            //     answer: (
            //         <>
            //             Funds are transferred directly to{' '}
            //             <Link
            //                 href={'https://www.nscclindia.com/'}
            //                 target={'_blank'}
            //             >
            //                 NSE clearing corporation
            //             </Link>{' '}
            //             which settles the purchase transaction initiated on the Jiraaf platform. You can also initiate the funds transfer (NEFT/RTGS) from your bank account upon successfully adding and verifying your NSE beneficiary account.
            //         </>
            //     ),
            // },
            {
                question: 'What is the payment process for placing an order?',
                answer: (
                    <>
                        After confirming your order, you will be redirected to a
                        payment method selection page. Simply choose your
                        preferred payment method and bank and proceed to the
                        secure payment gateway to complete your transaction.
                    </>
                ),
            },
            {
                question:
                    'What are the payment methods available with Jiraaf? ',
                answer: (
                    <>We support two payment methods: UPI and Net Banking</>
                ),
            },
            {
                question: 'What should I do if my payment fails?',
                answer: (
                    <>
                        If your payment fails, you will be redirected to a
                        payment failure page where you can retry the payment.
                        Alternatively, you can visit the "Pending Orders"
                        section on your dashboard to retry the payment.{' '}
                    </>
                ),
            },
            {
                question: 'Will my order be canceled if the payment expires?',
                answer: (
                    <>
                        Yes, if your payment expires (after 3 hours or at market
                        closure), your order will not be processed. To proceed,
                        you will need to initiate a new investment.
                    </>
                ),
            },
            {
                question:
                    'What happens if my order fails even after a successful payment?',
                answer: (
                    <>
                        In case your order fails after a successful payment, the
                        amount will be automatically refunded to your original
                        payment method. Refund processing typically takes 7–10
                        working days, depending on your bank.
                    </>
                ),
            },
            {
                question: 'What can I do if I face issues during payment?',
                answer: (
                    <>
                        If you encounter any problems, please contact our
                        support team at help@jiraaf.com or call your RM. In
                        order to avail quick assistance, you can provide your
                        order ID and transaction details.
                    </>
                ),
            },
        ],
    },
    //Repayment
    {
        header: 'Repayment',
        id: getId('Repayment'),
        questionBank: [
            {
                question:
                    'If repayments are made directly to my bank account, how does Jiraaf track them? Will you inform us if there is a default?',
                answer: (
                    <>
                        All repayments are managed directly by the issuer and
                        debenture trustee, with Jiraaf assisting in the event of
                        any delays or payment failures. However, the debenture
                        trustee is primarily responsible for keeping investors
                        informed about any delays or defaults and acting
                        accordingly.
                    </>
                ),
            },
            {
                question:
                    'Will there be compensation for delays in repayment in case of defaults?',
                answer: (
                    <>
                        Jiraaf cannot guarantee compensation or penal interest
                        in case of repayment delay or default. The debenture
                        trustee shall take all reasonable steps to recover any
                        such penalties or compensation in consultation with the
                        investors.
                    </>
                ),
            },
        ],
    },
    //AMO
    {
        header: 'After Market Orders (AMO)',
        id: getId('amo'),
        questionBank: [
            {
                question: 'What is an AMO?',
                answer: (
                    <p>
                        An After Market Order, or AMO, allows an investor to
                        place an order before and after regular market working
                        days and hours. Markets are typically open Monday
                        through Friday between 9:15 a.m. and 3:30 p.m.,
                        excluding national holidays. With the AMO feature now
                        available on Jiraaf, investors can place an order at
                        their convenience almost 24 hours a day and 365 days a
                        year.
                    </p>
                ),
            },
            {
                question: 'What are the benefits of AMO?',
                answer: (
                    <>
                        With Jiraaf’s AMO feature, you will get the following
                        benefits:
                        <ul className="list-disc ml-4 flex flex-col gap-2 mt-2">
                            <li>
                                <span className="p4-semibold md:p3-semibold">
                                    Ease of Investment:
                                </span>{' '}
                                You can place orders during non-market hours.{' '}
                            </li>
                            <li>
                                <span className="p4-semibold md:p3-semibold">
                                    Ample amount of Research time:
                                </span>{' '}
                                You get adequate time to go through all
                                necessary documents, even during off-market
                                hours, and trigger an investment post the same.{' '}
                            </li>
                            <li>
                                <span className="p4-semibold md:p3-semibold">
                                    Pre-booking option:
                                </span>{' '}
                                AMO basically works as a pre-booking option,
                                which helps you take advantage of great
                                investment opportunities
                            </li>
                        </ul>
                    </>
                ),
            },
            {
                question: 'How can I place an AMO order?',
                answer: (
                    <p>
                        AMO order placement is no different from a regular order
                        placement. The investment flow remains the same, and the
                        payment will be initiated immediately via the payment
                        gateway. The AMO order will be raised only if the
                        payment is successful.  
                    </p>
                ),
            },
            {
                question: 'How does Payment for an AMO order work?',
                answer: (
                    <>
                        <div className="mb-4">
                            <span className="p4-semibold md:p3-semibold">
                                Step 1:
                            </span>{' '}
                            The customer initiates an AMO order. Upon confirming
                            the order, the customer is redirected to the payment
                            gateway..{' '}
                        </div>
                        <div className="mb-4">
                            <span className="p4-semibold md:p3-semibold">
                                Step 2:
                            </span>{' '}
                            The payment is processed immediately. If the payment
                            is successful, the AMO order is raised.{' '}
                        </div>
                        <div className="flex flex-col gap-4">
                            <p>
                                <span className="p4-semibold md:p3-semibold">
                                    Step 3:
                                </span>{' '}
                                The customer will receive an email confirmation
                                from Jiraaf that the AMO order has been
                                successfully placed.{' '}
                            </p>
                            <div className="ml-4 md:ml-6">
                                <p>
                                    <span className="p4-semibold md:p3-semibold">
                                        For example,
                                    </span>
                                </p>
                                <ul className="list-disc ml-6 flex flex-col gap-2">
                                    <li>
                                        If you place an order on Sunday, the
                                        payment will be processed immediately.
                                    </li>
                                    <li>
                                        The AMO order will be raised only if the
                                        payment is successful. You will receive
                                        the email confirmation from our official
                                        Jiraaf address.{' '}
                                    </li>
                                    <li>
                                        The settlement of units to your Demat
                                        account will happen on the settlement
                                        day, i.e., Tuesday (T+1). 
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </>
                ),
            },
            {
                question: 'When will the settlement of units happen?',
                answer: (
                    <p>
                        Once the transaction is successful, the purchased units
                        will be transferred to your Demat account on settlement
                        day.
                    </p>
                ),
            },
            {
                question:
                    'Will I receive a confirmation after the order placement?',
                answer: (
                    <p>
                        Yes, investors receive an email from Jiraaf with all the
                        order details, like deal name, executed price, etc.,
                        after they place their orders on the platform.
                    </p>
                ),
            },
            {
                question: 'Can I cancel the AMO order once it is placed?',
                answer: (
                    <p>
                        No, investors are NOT allowed to cancel an AMO order
                        once it has been placed. Please initiate the order ONLY
                        if you plan to complete the purchase. Your AMO order
                        will be placed only if you complete the payment. It will
                        not be canceled once you complete the payment and raise
                        the AMO.
                    </p>
                ),
            },
            {
                question: 'What happens if payment for my AMO order fails?',
                answer: (
                    <p>
                        If the payment for your AMO order fails, you will have a
                        3-hour window to retry and complete the payment. If you
                        do not complete the payment within this time frame, your
                        order will expire, and you will need to place a new
                        order. 
                    </p>
                ),
            },
            {
                question:
                    'What happens if I do not complete the payment on time?',
                answer: (
                    <p>
                        If you do not complete the payment for your AMO order,
                        your order will not be raised with the Exchange.
                        However, you can come back and raise new orders
                        anytime.  
                    </p>
                ),
            },
            {
                question:
                    'Can an investor create an AMO order any time of the day?',
                answer: (
                    <>
                        <p>
                            Outside the working day trading hours (9:15 a.m. –
                            3:30 p.m.), the AMO order facility is available for
                            the majority of the day except 30 minutes earlier in
                            the working day (8:45 a.m. to 9:15 a.m.) and one
                            hour later (3:30 p.m. to 4:30 p.m.). On weekends and
                            holidays, there are no limitations.
                        </p>
                    </>
                ),
            },
            {
                question: 'What are the trading hours on the platform?',
                answer: (
                    <>
                        <p className="p4-semibold md:p3-semibold text-gray-800">
                            Trading Day (Working Business Days)
                        </p>
                        <div className="overflow-x-auto">
                            <div className="border border-gray-200 rounded-[10px] mt-4 min-w-[1060px] overflow-auto w-full">
                                <div className="grid-cols-12 grid bg-gray-100">
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-1 flex items-center">
                                        Sr. No.
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-2 flex items-center">
                                        Time Zone (IST)
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-2 flex items-center">
                                        Zone Name
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-2 flex items-center">
                                        Order Date
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-2 flex items-center">
                                        Earliest Settlement Date*
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-3 flex items-center">
                                        What Investor Will See & Pay?
                                    </div>
                                </div>
                                {[
                                    {
                                        sno: 1,
                                        timeZone: '00:00 to 9:00',
                                        ZoneName: 'AMO Time Zone',
                                        OrderDate: 'T+0 day',
                                        EarliestSettlementDate: 'T+1 day',
                                        WhatInvestorWillSeeAndPay:
                                            'Settlement Date Price (T+1)* ',
                                    },
                                    {
                                        sno: 2,
                                        timeZone: '9:00 to 9:15',
                                        ZoneName: 'No Investments zone',
                                        OrderDate: '-',
                                        EarliestSettlementDate: '-',
                                        WhatInvestorWillSeeAndPay: '-',
                                    },
                                    {
                                        sno: 3,
                                        timeZone: '9:15 to 15:30',
                                        ZoneName: 'Market time zone',
                                        OrderDate: 'T+0 day',
                                        EarliestSettlementDate: 'T+1 day',
                                        WhatInvestorWillSeeAndPay:
                                            'Settlement Date Price (T+1)*',
                                    },
                                    {
                                        sno: 4,
                                        timeZone: '15:30 - 15:45',
                                        ZoneName: 'No Investments zone',
                                        OrderDate: '-',
                                        EarliestSettlementDate: '-',
                                        WhatInvestorWillSeeAndPay: '-',
                                    },
                                    {
                                        sno: 5,
                                        timeZone: '15:45 - 23:59:59',
                                        ZoneName: 'AMO time zone',
                                        OrderDate:
                                            'T+0 day <br/> (Order to be placed only the following day)',
                                        EarliestSettlementDate: 'T+2 day',
                                        WhatInvestorWillSeeAndPay:
                                            'Settlement Date Price (T +2)*',
                                    },
                                ].map((time, index) => (
                                    <div
                                        className={`grid grid-cols-12 ${
                                            index === 5 ? '' : 'border-b'
                                        } border-gray-200`}
                                    >
                                        <div className="p4-regular p-4 border-r border-gray-200 text-primary-900 col-span-1 flex justify-center">
                                            {time.sno}
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-2">
                                            {time.timeZone}
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-2">
                                            {time.ZoneName}
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-2">
                                            <Text
                                                content={time.OrderDate}
                                                className="p4-regular text-gray-900"
                                                isInnerHtml={true}
                                            />
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-2">
                                            {time.EarliestSettlementDate}
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-3">
                                            {time.WhatInvestorWillSeeAndPay}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <p className="p4-semibold md:p3-semibold mt-4 text-gray-800">
                            Non-Trading Day (Holidays and Weekends)
                        </p>
                        <div className="overflow-x-auto">
                            <div className="border border-gray-200 rounded-[10px] mt-4 min-w-[1060px] overflow-auto w-full">
                                <div className="grid-cols-12 grid bg-gray-100">
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-1 flex items-center">
                                        Sr. No.
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-2 flex items-center">
                                        Time Zone (IST)
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-2 flex items-center">
                                        Zone Name
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-2 flex items-center">
                                        Order Date
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-2 flex items-center">
                                        Earliest Settlement Date*
                                    </div>
                                    <div className="p4-semibold text-gray-900 px-3 border-b border-r border-gray-200 py-3 col-span-3 flex items-center">
                                        What Investor Will See & Pay?
                                    </div>
                                </div>
                                {[
                                    {
                                        sno: 1,
                                        timeZone: '00:00 to 23:59:59',
                                        ZoneName: 'AMO Time Zone',
                                        OrderDate: 'Next business day',
                                        EarliestSettlementDate: 'T + 2 day*',
                                        WhatInvestorWillSeeAndPay:
                                            'Settlement Date Price (T +2)*',
                                    },
                                ].map((time, index) => (
                                    <div
                                        className={`grid grid-cols-12 ${
                                            index === 5 ? '' : 'border-b'
                                        } border-gray-200`}
                                    >
                                        <div className="p4-regular p-4 border-r border-gray-200 text-primary-900 col-span-1 flex justify-center">
                                            {time.sno}
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-2">
                                            {time.timeZone}
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-2">
                                            {time.ZoneName}
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-2">
                                            <Text
                                                content={time.OrderDate}
                                                className="p4-regular text-gray-900"
                                                isInnerHtml={true}
                                            />
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-2">
                                            {time.EarliestSettlementDate}
                                        </div>
                                        <div className="p4-regular text-gray-900 p-4 border-r border-gray-200 col-span-3">
                                            {time.WhatInvestorWillSeeAndPay}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <p className="p4-regular mt-4">
                            *Settlement Day will need to be a business trading
                            day. If it falls on a weekend or a holiday, it would
                            be processed on the next business day and the price
                            would be reflective of the same.{' '}
                        </p>
                    </>
                ),
            },
        ],
    },
    //Default
    {
        header: 'Default',
        id: getId('Default'),
        questionBank: [
            {
                question:
                    'Who is going to inform, and what steps do investors need to take in case of default?',
                answer: (
                    <>
                        The debenture trustee will inform investors through
                        formal communication in case of any default and will
                        also represent investors in recovering funds from the
                        assets offered as collateral by the borrower/issuer.
                    </>
                ),
            },
            {
                question:
                    'In case of default by the borrower, can losses be claimed while filing income tax returns?',
                answer: (
                    <>
                        Yes, losses incurred due to defaults by the borrower can
                        be claimed as capital loss while filing income tax
                        returns. It’s advisable to consult with a tax advisor or
                        CA for accurate filing and to ensure compliance with the
                        latest tax regulations.
                    </>
                ),
            },
            {
                question: 'How does Jiraaf handle default or credit events?',
                answer: (
                    <>
                        The primary responsibility for representing investors
                        before the issuer and regulators lies with the debenture
                        trustee. While Jiraaf will provide all possible support
                        in the event of a default, we strongly recommend that
                        investors stay in touch with the debenture trustee to
                        remain informed about the proceedings.
                    </>
                ),
            },
        ],
    },
    //Customer Support
    {
        header: 'Customer Support',
        id: getId('Customer Support'),
        questionBank: [
            {
                question: 'What kind of customer support does Jiraaf offer?',
                answer: (
                    <>
                        Jiraaf offers continuous customer support through
                        various channels like call, chat, and email. You can
                        reach out to the designated relationship management as
                        well for any support during your investment journey.
                    </>
                ),
            },
        ],
    },
    //Miscellaneous
    {
        header: 'Miscellaneous',
        id: getId('Miscellaneous'),
        questionBank: [
            {
                question:
                    'Is Jiraaf compliant with applicable regulatory norms?',
                answer: (
                    <>
                        Yes, Jiraaf complies with the regulatory norms laid out
                        by SEBI and RBI for online bond platforms.
                    </>
                ),
            },
            {
                question: 'Is there any service fee to invest on Jiraaf?',
                answer: (
                    <>
                        We do not charge our investors any service or platform
                        fees at this point. If and when we start charging any
                        such fee from our customers, Jiraaf is committed to
                        communicating the same transparently.
                    </>
                ),
            },
            {
                question:
                    'Can Jiraaf rank opportunities by safety instead of just using low/medium/high-risk categories?',
                answer: (
                    <>
                        Currently, our opportunities are listed as per risk
                        categories (low, medium, high) on the platform,
                        according to the rating provided by the external
                        agencies (ICRA, CRISIL, CARE, INDIA Ratings) and due
                        diligence performed by the Jiraaf team, and that denotes
                        the safety of the investments.
                    </>
                ),
            },
            {
                question:
                    'Under which section will my securities reflect in my Demat account?',
                answer: (
                    <>
                        The securities purchased on the Jiraaf platform are
                        commonly reflected under the “holdings” tab/section in
                        your depository participant account. However, it might
                        differ based on your depository (i.e., Zerodha, Groww,
                        etc.).
                    </>
                ),
            },
            {
                question: 'What does clean price and dirty price mean?',
                answer: (
                    <>
                        Simply put, a clean price denotes the bond's price
                        without accrued interest. It is the price an investor
                        pays to buy a bond without considering any interest that
                        the bond has accrued. The dirty price is the bond's
                        price, including accrued interest. It is the actual
                        price an investor pays to buy a bond, considering any
                        interest that the bond has accrued.
                    </>
                ),
            },
        ],
    },
    //Insurance
    {
        header: 'Insurance',
        id: getId('Insurance'),
        questionBank: [
            {
                question: 'Are my investments covered under DICGC insurance?',
                answer: (
                    <>
                        The DICGC’s insurance protection is limited to fixed
                        deposits, recurring deposits, and savings and current
                        account balances with banks. Bonds are excluded from
                        this coverage.
                    </>
                ),
            },
        ],
    },
    // PRODUCTS
    {
        isMainHeader: true,
        mainHeader: 'Products',
        id: getId('Products'),
    },
    // CORPORATE BONDS
    {
        header: 'Corporate Bonds',
        id: getId('Corporate Bonds'),
        questionBank: [
            {
                question:
                    'What is the interest rate or returns on corporate bonds in India?',
                answer: (
                    <p>
                        Compared to conventional fixed income avenues like fixed
                        deposits or recurring deposits, listed corporate bonds
                        provide better annual returns at varied risk levels,
                        from low to high, typically yielding between 8% and 18%.
                    </p>
                ),
            },
            {
                question:
                    'What is the difference between corporate FD and corporate bond?',
                answer: (
                    <p>
                        A corporate FD is a fixed deposit issued ONLY by
                        financial institutions for a defined tenure, and it
                        typically offers better returns than bank FDs. On the
                        other hand, corporate bonds are fixed-income securities
                        that allow organizations to raise funds for various
                        needs without diluting ownership and generally offer
                        better returns than corporate FDs. 
                    </p>
                ),
            },
            {
                question:
                    'What are some of the risks involved with investing in corporate bonds?',
                answer: (
                    <p className="mb-2">
                        Some of the inherent risks associated with corporate
                        bonds include:
                    </p>
                ),
                subQuestions: [
                    {
                        question: 'Credit risk',
                        answer: (
                            <>
                                This refers to when a company fails to make
                                interest or principal payments timely. This is
                                where credit ratings by external agencies
                                (long-term and short-term ratings), which are
                                based on a company’s financial health, come in.
                                Long-term ratings range from AAA to D, with AAA
                                being the best. Some of the examples of external
                                credit rating companies in India include CRISIL,
                                Acute, and ICRA. 
                            </>
                        ),
                    },
                    {
                        question: 'Liquidity risk',
                        answer: (
                            <>
                                When the investor tries to sell a bond and
                                doesn’t get the price of its true value, it is
                                called liquidity risk. 
                            </>
                        ),
                    },
                    {
                        question: 'Inflation risk',
                        answer: (
                            <>
                                Inflation causes a decline in purchasing power
                                when there is a general rise in the price of
                                goods. The principal payments received by
                                investors will thus be able to purchase fewer
                                goods and services with overtime inflation.
                            </>
                        ),
                    },
                    {
                        question: 'Call risk',
                        answer: (
                            <>
                                It refers to the risks associated with the
                                issuer deciding to “call” the bond, i.e., buy
                                back the bond before the bond’s maturity date,
                                which may cause the bondholder to lose out on
                                future revenue. 
                            </>
                        ),
                    },
                ],
            },
            {
                question: 'When do corporate bonds mature?',
                answer: (
                    <p>
                        Corporate bonds’ maturities range from long (more than
                        ten years) to medium (four to ten years) and short (less
                        than three years). Generally, long-term bonds entail
                        additional risks but offer better interest rates.
                    </p>
                ),
            },
            {
                question:
                    'What is the difference between government bonds and corporate bonds?',
                answer: (
                    <p>
                        As the names imply, bonds issued by public or private
                        organizations are called{' '}
                        <SpanElement content="corporate bonds" />, and those
                        issued by the government are called{' '}
                        <SpanElement content="government bonds" />.
                    </p>
                ),
            },
        ],
    },
    // TREASURY BILLS
    {
        header: 'Treasury Bills',
        id: getId('Treasury Bills'),
        questionBank: [
            {
                question: 'Are Treasury bills debt or equity investments?',
                answer: (
                    <p>
                        Treasury bills are debt instruments that come in 3
                        tenures (91 days, 182 days, and 364 days) and are sold
                        below their face value. In other words, investors buy
                        these instruments at discounted prices but get the full
                        value when the T-bills mature.
                    </p>
                ),
            },
            {
                question:
                    'What is the difference between a Treasury bill and a bond?',
                answer: (
                    <p>
                        Corporate bonds have long maturities, higher risk,
                        better returns, and periodic repayment schedules defined
                        by the advertised coupon rate compared to Treasury
                        bills, which are government securities with shorter
                        tenures, zero coupon rates, sold at a discount, and
                        almost zero risk with repayment made at maturity.
                    </p>
                ),
            },
            {
                question: 'Who issues Treasury bills in India?',
                answer: (
                    <p>
                        Treasury bills are issued by the Reserve Bank of India
                        (RBI) on behalf of the Indian Government. Their interest
                        rate is determined by market forces, and the RBI
                        conducts auctions at regular intervals to sell T-bills,
                        which can be purchased by trusts, individuals, banks,
                        and institutions.
                    </p>
                ),
            },
            {
                question: 'What is the interest rate on T-bills in RBI?',
                answer: (
                    <p>
                        As of March 2025, T-bills in India fetch yields ranging
                        from 6.19% for 91 days to 6.59% for 182 days, and 6.63%
                        for 364 days.
                    </p>
                ),
                note: (
                    <p>
                        Note: These rates are indicative and subject to change
                        as per the regulatory policies and market forces.
                    </p>
                ),
            },
            {
                question: 'How to buy Treasury bills in India?',
                answer: (
                    <p>
                        You can purchase T-bills from a broker or bank that has
                        permission to participate in the RBI auction. To
                        purchase Treasury bills, you need a trading platform, a
                        Demat account, and a trading account. Customers can also
                        purchase T-bills in the secondary market or online bond
                        platforms.
                    </p>
                ),
            },
        ],
    },

    // Sovereign Gold Bonds (SGBs)
    /*{
        header: 'Sovereign Gold Bonds',
        id: getId('Sovereign Gold Bonds'),
        questionBank: [
            {
                question: 'Is sovereign gold bond a good investment?',
                answer: (
                    <>
                        Those who want to diversify their portfolio and are
                        looking for relatively{' '}
                        <SpanElement
                            content="safe investments with relatively better returns in
                            India"
                        />{' '}
                        can opt for SGBs. These gold bonds allow you to invest
                        in gold without having to rush to lockers to store the
                        physical asset, and they are also secured by the RBI.
                    </>
                ),
            },
            {
                question: 'How much gold can I buy with SGBs?',
                answer: (
                    <>
                        Per fiscal year, an individual can purchase up to 4 kg
                        of gold since it is the maximum limit of subscription,
                        and the minimum permissible investment will be one gram
                        of gold.
                    </>
                ),
            },
            {
                question: 'Is SGB tax-free?',
                answer: (
                    <>
                        You won’t have to pay capital gains tax if you hold the
                        SGB till the maturity date, and no TDS is applicable
                        either. However, if you sell your{' '}
                        <SpanElement content={'gold bond investments'} /> before
                        maturity, then capital gain taxes will be levied.
                        Interest income from the coupon rate is taxed as per the
                        tax slab.
                    </>
                ),
            },
            {
                question: 'What are the disadvantages of gold bonds?',
                answer: (
                    <>
                        Some of the disadvantages of{' '}
                        <SpanElement content={'sovereign gold bonds'} /> are no
                        physical possession of gold, a cap on how many SGBs
                        individuals can purchase, and longer maturity dates.
                    </>
                ),
            },
            {
                question: 'What are the benefits of Sovereign Gold Bonds?',
                answer: <p>The benefits of SGB are as follows:</p>,
                subQuestions: [
                    {
                        question: '',
                        answer: 'Safe as they are backed by the government',
                    },
                    {
                        question: '',
                        answer: 'Potentially big gains for investors as gold prices typically appreciate over time',
                    },
                    {
                        question: '',
                        answer: 'Easy to buy and sell',
                    },
                    {
                        question: '',
                        answer: '2.5% coupon interest rate per annum',
                    },
                    {
                        question: '',
                        answer: 'Can be used as collateral for loans',
                    },
                ],
            },
            {
                question: 'What is the price of SGB in India in 2023?',
                answer: (
                    <p>
                        Subscribers can purchase Sovereign Gold Scheme 2023-24
                        (Series I) at a price of Rs. 5,926 per gram, which has
                        been fixed by the government.
                    </p>
                ),
            },
        ],
    },*/
    // G-Sec/SDL
    {
        header: 'G-Sec/SDL',
        id: getId('gsec-sdl'),
        questionBank: [
            {
                question: 'What is the difference between G-Sec and SDL?',
                answer: (
                    <p>
                        The primary difference between these is that SDLs are
                        issued for state governments, and G-Secs are issued for
                        the central government. This makes them some of the best
                        bonds for conservative investors to invest in India,
                        with risk close to zero and returns better than fixed
                        deposits (FDs). Both are backed by the RBI. G-Sec's
                        tenure ranges from 5 years to 40 years, and that of SDLs
                        is typically 10 years but can be higher.
                    </p>
                ),
            },
            {
                question: 'Why should you buy SDL target maturity funds?',
                answer: (
                    <p>
                        Investors can better plan and align their investment
                        strategies with their financial goals by opting for SDL
                        target maturity funds. These funds have a fixed maturity
                        term, pay interest semi-annually, and repay the
                        principal at maturity. They also offer liquidity
                        benefits to investors as they have no lock-in period.
                    </p>
                ),
            },
            {
                question: 'Is SDL risk-free?',
                answer: (
                    <p>
                        SDLs carry lesser risk compared to corporate bonds.
                        Additionally, they are backed by the Reserve Bank of
                        India (RBI), which has the authority to repay holders of
                        SDL securities using money that the central government
                        allocates to states.
                    </p>
                ),
            },
            {
                question: 'Who issues G-Sec in India?',
                answer: (
                    <p>
                        The Reserve Bank of India issues G-Secs on behalf of the
                        central government. You can invest in these bonds
                        through your Demat account by registering on the NSE
                        goBID app, directly via the RBI Retail Direct portal, or
                        the Jiraaf platform.
                    </p>
                ),
            },
            {
                question: 'What is the rate of a seven-year G-Sec in India?',
                answer: (
                    <p>
                        As of March 20, 2025, the yield on a seven-year Indian
                        G-Sec (Government Security) is around 6.754%.
                    </p>
                ),
            },
            {
                question: 'Who can invest in G-Secs?',
                answer: (
                    <p>
                        Government securities in India can be bought by trusts,
                        companies, HUFs (Hindu Undivided Family), financial
                        institutions, mutual funds, and NRIs (Non-Resident
                        Indians), apart from retail investors.
                    </p>
                ),
            },
        ],
    },
    // Securitized Debt Instruments
    {
        header: 'Securitized Debt Instruments',
        id: getId('sdi'),
        questionBank: [
            {
                question:
                    'What is the difference between corporate bonds and SDI’s?',
                answer: (
                    <div className="border border-gray-200 rounded-xl">
                        <div className="hidden grid-cols-3 md:grid">
                            <div className="p3-semibold text-gray-900 p-3 border-b border-r border-gray-200">
                                Points of difference
                            </div>
                            <div className="p3-semibold text-gray-900 p-3 border-b border-r border-gray-200">
                                Corporate Bonds
                            </div>
                            <div className="p3-semibold text-gray-900 p-3 border-b border-r border-gray-200">
                                SDIs
                            </div>
                        </div>
                        {[
                            {
                                pointOfDiff: 'Structure',
                                corporateBonds:
                                    'Debt securities issued by corporations to raise funds with a promise to pay fixed periodic repayments to investors. ',
                                sdis: 'Securities representing ownership in a pool of underlying income generating assets. The income generated is in turn distributed to investors. ',
                            },
                            {
                                pointOfDiff: 'Returns',
                                corporateBonds: '8-18%',
                                sdis: '8-15%',
                            },
                            {
                                pointOfDiff: 'Rating',
                                corporateBonds: 'Borrower entity is rated',
                                sdis: 'Pool of assets is rated',
                            },
                            {
                                pointOfDiff: 'Diversification',
                                corporateBonds: 'Investment in a single bond',
                                sdis: 'Investment in a pool of assets',
                            },
                            {
                                pointOfDiff: 'Taxation',
                                corporateBonds:
                                    'Taxed as per tax slab. TDS of 10% applicable.',
                                sdis: 'Taxed as per Tax slab. TDS of 10% for NCDs and 25% for PTCs',
                            },
                        ].map((diff, index) => (
                            <div
                                className={`grid grid-cols-1 md:grid-cols-3 ${
                                    index === 4 ? '' : 'border-b'
                                } border-gray-200`}
                            >
                                <div className="p3-semibold md:p3-medium px-3 pb-1 pt-2 md:p-3 border-r border-gray-200 text-basicBlack md:text-primary-500">
                                    {diff.pointOfDiff}
                                </div>
                                <div className="p4-regular md:p3-medium text-gray-500 py-1 px-3 md:p-3 border-r border-gray-200">
                                    <span className="p4-medium text-primary-500 md:hidden">
                                        Corporate Bond:{' '}
                                    </span>{' '}
                                    {diff.corporateBonds}
                                </div>
                                <div className="p4-regular md:p3-medium text-gray-500 pt-1 pb-2 px-3 md:p-3 border-r border-gray-200">
                                    <span className="p4-medium text-primary-500 md:hidden">
                                        SDIs:{' '}
                                    </span>{' '}
                                    {diff.sdis}
                                </div>
                            </div>
                        ))}
                    </div>
                ),
            },
            {
                question: 'What are the risks involved in SDIs?',
                subQuestions: [
                    {
                        question: ' Credit risk',
                        answer: (
                            <>
                                The creditworthiness of borrowers in the
                                underlying pool of loans can affect the
                                performance of SDIs. 
                            </>
                        ),
                    },
                    {
                        question: 'Liquidity risk',
                        answer: (
                            <>
                                SDIs are often traded in the secondary market.
                                The ability to liquidate these may vary
                                depending on market conditions and demand for
                                the underlying security.
                            </>
                        ),
                    },
                    {
                        question: 'Prepayment risk',
                        answer: (
                            <>
                                Early repayments could impact SDI investors'
                                cumulative interest income and total return on
                                investment earned from the opportunity invested.
                            </>
                        ),
                    },
                ],
            },
            {
                question: 'How are SDIs taxed? ',
                answer: 'The interest component received is categorized as “Income from Other Sources” and will be taxed as per tax slab. TDS at 10% will be deducted on the interest component at the time of repayment.',
            },
            {
                question:
                    'What types of assets are commonly securitized into SDI’s?',
                answer: 'Assets commonly securitized can broadly be classified into three categories: Loan receivables: Receivables from car loans, personal loans, gold loans etc. Invoice receivables: Receivables from invoices raised by entities. Income generated by leasing real assets: Income generated by leasing assets like cars, trucks, machinery, real estate etc.',
            },
            {
                question: 'Are SDI’s liquid investments?',
                answer: 'SDIs are often traded in the secondary market, providing some liquidity to investors. However, liquidity may vary depending on market conditions and the specific characteristics of the certificates.',
            },
        ],
    },
    ,
    // Fixed Deposit
    ...(isFDFeatureEnabled
        ? [
              {
                  header: 'Fixed Deposit',
                  id: getId('Fixed Deposit'),
                  questionBank: [
                      {
                          question:
                              'What is a Fixed Deposit and how does it work?',
                          answer: (
                              <p>
                                  A fixed deposit allows you to invest a lump
                                  sum for a predetermined period at a fixed
                                  interest rate. The interest earned on your
                                  deposit compounds over time, and at maturity,
                                  you receive both the principal and interest.
                                  You can get FDs from banks and financial
                                  institutions as a low-risk investment option,
                                  to achieve your financial goals with certainty
                                  and safety.
                              </p>
                          ),
                      },
                      {
                          question: 'Is an FD right for your portfolio?',
                          answer: (
                              <p>
                                  Every investment asset has a different role to
                                  play in your portfolio. FDs provide guaranteed
                                  returns with minimal risk. They help preserve
                                  your capital and even grow it in volatile
                                  markets, offering liquidity and predictable
                                  interest. Large bank FDs might not always beat
                                  inflation, but they can be used conveniently
                                  for short-term goals or to build emergency
                                  funds or to cushion your portfolio from
                                  volatility. FDs from small banks and NBFCs can
                                  even help you beat inflation.
                              </p>
                          ),
                      },
                      {
                          question:
                              'What types of Fixed Deposit accounts are available?',
                          answer: (
                              <p>
                                  Financial institutions offer a variety of
                                  fixed deposit accounts to suit different
                                  needs. These include standard FDs with fixed
                                  returns, tax-saving FDs that qualify for
                                  Section 80C deductions, and senior citizen
                                  FDs, that offer higher interest rates. Flexi
                                  FDs are linked to your savings account for
                                  automatic investments, while NRI FDs are
                                  designed for non-resident Indians. Choose the
                                  FD type that best aligns with your financial
                                  goals.
                              </p>
                          ),
                      },
                      {
                          question:
                              'What is the minimum and the maximum tenure for a Fixed Deposit?',
                          answer: (
                              <p>
                                  Fixed deposits offer tenures ranging from 7
                                  days to 10 years. Short-term FDs provide
                                  liquidity for emergencies or urgent
                                  requirements, while long-term FDs maximize
                                  returns through the power of compounding. The
                                  best strategy is to opt for FD laddering
                                  wherein you invest in multiple FDs with
                                  different maturity dates to strike a balance
                                  between liquidity and returns.
                              </p>
                          ),
                      },
                      {
                          question:
                              'What is the eligibility criteria for opening an FD?',
                          answer: (
                              <p>
                                  To be eligible for opening an FD account, you
                                  must be an Indian citizen, whether you are a
                                  resident or a non-resident. Eligible entities
                                  include individuals, companies, partnership
                                  firms, businesses, senior citizens, and
                                  minors. The essential documents required
                                  typically include proof of identity, proof of
                                  address, and proof of date of birth. Keep in
                                  mind that the specific process and
                                  documentation requirements may vary across
                                  different financial institutions.
                              </p>
                          ),
                      },
                      {
                          question: 'Are banks the only ones to offer FDs?',
                          answer: (
                              <p>
                                  Banks are not the only ones to offer FDs.
                                  NBFCs and India Post Offices can also offer
                                  fixed deposits.
                                  <br /> As per Section 451(c) of the RBI Act,
                                  NBFCs can carry the business of a financial
                                  institution without a full banking licence.
                                  NBFCs offer FDs, credit facilities, savings &
                                  investment plans, insurance, etc.
                              </p>
                          ),
                      },
                      {
                          question:
                              "What is a payout account? Can I use someone else's bank account?",
                          answer: (
                              <p>
                                  A payout account is the designated bank
                                  account where the funds from your fixed
                                  deposit (FD) will be credited upon maturity.
                                  This is the account where you will receive
                                  your investment returns. For safety and
                                  security reasons, it is mandatory to provide
                                  your own bank account details to receive the
                                  payout.
                              </p>
                          ),
                      },
                      {
                          question:
                              'How often do Fixed Deposits (FDs) compound?',
                          answer: (
                              <p>
                                  The frequency at which interest is compounded
                                  for Fixed Deposits varies by institution. For
                                  example, bank interests typically compound on
                                  a quarterly basis. At Bajaj, the compounding
                                  frequency is annual, while at Shriram,
                                  interest is compounded monthly.
                              </p>
                          ),
                      },
                      {
                          question:
                              'Is KYC mandatory for opening a Fixed Deposit?',
                          answer: (
                              <p>
                                  Yes, KYC is mandatory for opening a Fixed
                                  Deposit account to comply with regulatory
                                  requirements and ensure the authenticity of
                                  the account holder.
                              </p>
                          ),
                      },
                      {
                          question:
                              'What documents are required for KYC in Fixed Deposits?',
                          answer: (
                              <p>
                                  You need to provide proof of identity (e.g.,
                                  Aadhaar card, PAN card), proof of address
                                  (e.g., utility bill, passport), and proof of
                                  date of birth.
                              </p>
                          ),
                      },
                      {
                          question:
                              'What is CKYC, and is consent required to fetch CKYC data for opening an FD?',
                          answer: (
                              <p>
                                  CKYC stands for Central Know Your Customer, an
                                  initiative by the Government of India. It
                                  streamlines the customer onboarding process by
                                  consolidating all relevant KYC information in
                                  one place. <br />
                                  Consent is necessary to access this data
                                  because it contains your personal information.
                                  We use this information to ensure a safer and
                                  faster onboarding process.
                              </p>
                          ),
                      },
                      {
                          question:
                              'Why is video KYC required? What if it fails?',
                          answer: (
                              <p>
                                  Video KYC is mandated by RBI guidelines as a
                                  verification step for all investors. <br />
                                  In the rare event that your Video KYC process
                                  fails, you can retry the investment within 2
                                  days of booking the FD during banking hours.
                              </p>
                          ),
                      },
                      {
                          question:
                              'Why is my money deducted before video KYC?',
                          answer: (
                              <p>
                                  The money is deducted and invested with the
                                  bank before completing Video KYC to ensure you
                                  start earning interest immediately. This step
                                  is taken to avoid any delay in interest
                                  accumulation.
                                  <br /> If the Video KYC process is not
                                  completed, the bank will refund your money
                                  within 7 working days.
                              </p>
                          ),
                      },
                      {
                          question: 'Why did my payment fail?',
                          answer: (
                              <div>
                                  There are three common reasons for payment
                                  failures:
                                  <ol className="pl-4 list-decimal">
                                      <li>
                                          Exceeding Bank's Pre-Assigned Limit:
                                          If the payment amount exceeds your
                                          bank's pre-assigned limit, which
                                          typically ranges from ₹25,000 to ₹2
                                          lakh. You can increase this limit
                                          through net banking.
                                      </li>
                                      <li>
                                          Exceeding UPI Payment Limit: If you
                                          surpass your daily UPI payment limit.
                                          The total amount of all payments
                                          within 24 hours should remain within
                                          the specified limit, usually ₹1 lakh
                                          per day.
                                      </li>
                                      <li>
                                          Bank Server Issues: If there is an
                                          issue with the bank's server. When
                                          making a payment, you are redirected
                                          to a page that connects you to your
                                          bank or UPI platform. Occasionally,
                                          this connection might fail.
                                      </li>
                                  </ol>
                              </div>
                          ),
                      },
                      {
                          question: 'What happens if my payment fails?',
                          answer: (
                              <p>
                                  In the unlikely event that your payment fails
                                  but the amount has been deducted from your
                                  account, there's no need to worry. The
                                  deducted amount will be refunded to your
                                  source account within 2 to 4 working days.
                              </p>
                          ),
                      },
                      {
                          question:
                              'Can an FD be withdrawn partially and are there any charges for early withdrawals?',
                          answer: 'Most banks permit partial withdrawals from Fixed Deposits (FDs), but the terms can vary. You might face penalties, which could reduce the applicable interest rate. Some banks offer special FDs that do not have withdrawal penalties after a lock-in period. If you need liquidity, consider options like Flexi FDs or laddering your deposits. Always check the withdrawal rules before investing to avoid unexpected charges or losses.',
                      },
                      {
                          question:
                              'Can I prematurely withdraw my FDs from Jiraaf? What interest rate will I receive?',
                          answer: (
                              <>
                                  Yes, you can withdraw your fixed deposit from
                                  Jiraaf before maturity, but only after the
                                  lock-in period is complete.
                                  <br />
                                  In such cases, the interest rate remains the
                                  same, but the duration for which you earn
                                  interest changes, based on when you decide to
                                  withdraw. Therefore the returns you earn will
                                  be the applicable interest rate minus any
                                  penalty applied.
                              </>
                          ),
                      },
                      {
                          question:
                              'Are there any withdrawal processing charges?',
                          answer: 'No, Jiraaf does not charge any processing fees for FD withdrawals. You can withdraw the amount at maturity and receive it directly in your source account.',
                      },
                      {
                          question: 'Is the interest earned on FDs taxable?',
                          answer: 'Yes, the interest earned on FDs is taxable and must be reported under the head ‘Income from Other Sources’ in your Income Tax Return.',
                      },
                      {
                          question: 'What is TDS on FD interest?',
                          answer: 'Tax Deducted at Source (TDS) is a tax that banks deduct on the interest earned from FDs if it exceeds a certain threshold. For individuals below the age of 60 years, the threshold is ₹40,000 in a financial year. For senior citizens, the threshold is ₹50,000.',
                      },
                      {
                          question: 'How are FDs taxed?',
                          answer: 'The interest earned from Fixed Deposits is taxed based on your applicable income tax slab. For example, if you are in the 30% tax bracket and have a ₹1 lakh FD at an interest rate of 6%, you will earn ₹6,000 in interest for the year. You will need to pay 30% tax on this interest, which amounts to ₹1,800.',
                      },
                  ],
              },
          ]
        : []),
    // Structured Debt
    // {
    //     header: 'Structured Debt',
    //     id: getId('Structured Debt'),
    //     questionBank: [
    //         {
    //             question: 'What are the benefits of structured debt?',
    //             answer: <p>Some of its benefits include:</p>,
    //             subQuestions: [
    //                 {
    //                     question: '',
    //                     answer: 'Higher returns than conventional investments',
    //                 },
    //                 {
    //                     question: '',
    //                     answer: 'Helps with portfolio diversification',
    //                 },
    //                 {
    //                     question: '',
    //                     answer: 'Tailored credit risk exposure to meet investment goals',
    //                 },
    //             ],
    //         },
    //         {
    //             question: 'What are the risks of structured debt?',
    //             answer: <p>Some of the risks include:</p>,
    //             subQuestions: [
    //                 {
    //                     question: '',
    //                     answer: "Credit Risk tied to the issuer's creditworthiness",
    //                 },
    //                 {
    //                     question: '',
    //                     answer: 'Liquidity Risk in terms of the ability to liquidate before maturity',
    //                 },
    //                 {
    //                     question: '',
    //                     answer: 'Furthermore, investors can also be affected if the issuer “calls” the structured debt before maturity, especially if market interest rates are declining.',
    //                 },
    //             ],
    //         },
    //     ],
    // },
];

export const faqsHome = [
    {
        header: '',
        id: 'faqsHome',
        questionBank: [
            {
                question: 'What are Bonds?',
                answer: (
                    <>
                        Bonds are types of fixed-income securities issued by
                        corporations, governments, and organizations to
                        investors like you in exchange for periodic interest
                        payments (monthly/ quarterly/ annually). Your principal
                        amount is repaid at maturity. <br />
                        Essentially, bonds act as loans, providing you with
                        stable returns while helping issuers raise funds for
                        projects, operations, and growth. They are less risky
                        than equities, making them ideal for stable investments.
                    </>
                ),
            },
            {
                question: 'Why invest in bonds?',
                answer: (
                    <>
                        Bonds come with steady market-competitive returns while
                        carrying lesser risk than equities, offering a cushion
                        to your investment portfolio from market volatility.
                        They are excellent investment options to diversify your
                        portfolio. They offer consistent income in the form of
                        interest payments while also aiding in capital
                        preservation and tax efficiency.
                    </>
                ),
            },
            {
                question: 'Who can invest in bonds?',
                answer: (
                    <>
                        There is a bond for every investor and every purpose.
                        You can invest in bonds irrespective of your age and
                        investment portfolio size. Bonds can help you with
                        capital preservation, capital growth, tax efficiency,
                        income generation, and general financial portfolio
                        diversification. For example, government bonds can help
                        you preserve your capital, corporate bonds might be
                        better for growing wealth, coupon-paying bonds can
                        provide steady payouts, and tax-free bonds suit those
                        looking for tax benefits.
                    </>
                ),
            },
            {
                question: 'Where can I buy bonds in India?',
                answer: (
                    <>
                        In India, authorized brokers, stock exchanges, banks,
                        and online investing platforms focused on fixed-income
                        assets are the places to buy bonds. <br />
                        You can choose your method based on your goals,
                        convenience, range of options, etc. Try to evaluate the
                        characteristics of the bond before investing through any
                        platform.
                    </>
                ),
            },
            {
                question: 'What are the benefits of buying bonds online?',
                answer: (
                    <>
                        Buying bonds online is convenient, quick, and
                        transparent. You can access a wide range of options,
                        compare returns, and evaluate issuers in one place.
                        <br />
                        Online platforms provide detailed insights, enable
                        secure transactions, and offer flexible investment
                        choices, making it easier to invest in bonds.
                        Additionally, you save time and effort by managing your
                        investments seamlessly from anywhere, with expert
                        support often available to guide your decisions.
                    </>
                ),
            },
            {
                question: 'Is it safe to invest in bonds?',
                answer: (
                    <>
                        Investing in bonds is generally considered a safe
                        option, as they are less volatile than stocks. However,
                        safety depends on the issuer’s creditworthiness and the
                        type of bond. Government bonds are considered the
                        safest, while corporate bonds may carry slightly higher
                        risks but offer better returns.
                    </>
                ),
            },
        ],
    },
];
